const devicePageMap: {
    [key: string]: {
        supportDeviceSwitch: boolean; // 是否支持设备切换
        path?: string; // 为空或相对地址，设备切换时多对一的场景使用 为空表示和pc端同路由
        mobile?: string; // 移动端前缀
    };
} = {
    // 课程详情
    courseDetails: {
        supportDeviceSwitch: true
    },
    register: {
        supportDeviceSwitch: true,
        mobile: 'appidx'
    },
    login: {
        supportDeviceSwitch: true,
        mobile: 'appidx'
    },
    redirect: {
        supportDeviceSwitch: true,
        mobile: 'appidx'
    }
};
export default devicePageMap;
